<template>
	<div class="input-group input-group-birthday">
		<div class="input-group-prepend">
			<span class="input-group-text no-border-radius input-group-text-mobile" :class="[{'is-invalid': errorinfo.hasError}, {'disabled' : isProcessing}, inputclass]">
				Birthday <span class="input-mobile-border">&nbsp;</span></span>
		</div>
		<input class="form-control input-birthday no-border-radius" id="month-input" @input="onInput($event, 'month')" v-model="month" 
			type="number"
			placeholder="MM"
			:disabled="isProcessing"
			:class="[{'is-invalid': errorinfo.hasError}, inputclass]"/>
		<input class="form-control input-birthday no-border-radius" id="day-input" @input="onInput($event, 'day')" v-model="day" 
			type="number"
			placeholder="DD"
			:disabled="isProcessing"
			:class="[{'is-invalid': errorinfo.hasError}, inputclass]"/>
		<input class="form-control input-birthday no-border-radius" id="year-input" @input="onInput($event, 'year')" v-model="year" 
			type="number" 
			placeholder="YYYY"
			:disabled="isProcessing"
			:class="[{'is-invalid': errorinfo.hasError}, inputclass]"/>
		<small class="invalid-feedback" v-if="errorinfo.hasError">{{errorinfo.msg}}</small>
	</div>
</template>

<script>

export default {
	props: {
		value: {},
		placeholder: String,
		inputclass: String,
		isProcessing: Boolean,
		errorinfo: {type: Object, default: () => ({})}
	},
	mounted(){
		this.setInputFilter(document.getElementById("month-input"), function(value) { return /^\d*$/.test(value) });
		this.setInputFilter(document.getElementById("day-input"), function(value) { return /^\d*$/.test(value); });
		this.setInputFilter(document.getElementById("year-input"), function(value) { return /^\d*$/.test(value); });

		this.currentYear = new Date().getFullYear();
	},
	data: function() {
		return {
			in_dateOfBirth: {},
			month: undefined,
			day: undefined,
			year: undefined,
			currentYear: undefined,
		}
	},
	methods: {
		onInput(evt, field){
			
			if(field == 'month'){

				if(this.month.length > 2){
					this.month = this.month.substring(0,2);
				} else {
					this.in_dateOfBirth.month = this.month;
				}
			}

			if(field == 'day'){

				if(this.day.length > 2){
					this.day = this.day.substring(0,2);
				} else {
					this.in_dateOfBirth.day = this.day;
				}
			}

			if(field == 'year'){
				if(this.year.length > 4){
					this.year = this.year.substring(0,4);
				} else {
					this.in_dateOfBirth.year = this.year;
				}
			}

			this.in_dateOfBirth.isValid = true;
			if(this.in_dateOfBirth.month <= 0 || this.in_dateOfBirth.month > 12 || this.in_dateOfBirth.month == null){
				this.in_dateOfBirth.isValid = false;
				this.in_dateOfBirth.errorMsg = 'Month is invalid';
			} else if (this.in_dateOfBirth.day <= 0 || this.in_dateOfBirth.day > 31 || this.in_dateOfBirth.day == null){
				this.in_dateOfBirth.isValid = false;
				this.in_dateOfBirth.errorMsg = 'Day is invalid';
			} else if (this.in_dateOfBirth.year < 1900 || this.in_dateOfBirth.year > this.currentYear || this.in_dateOfBirth.year == null){
				this.in_dateOfBirth.isValid = false;
				this.in_dateOfBirth.errorMsg = 'Year is invalid';
			} else if (this.currentYear - this.in_dateOfBirth.year < 18 ) {
				this.in_dateOfBirth.isValid = false;
				this.in_dateOfBirth.errorMsg = 'Must be of legal age';
			}

			if(this.in_dateOfBirth.isValid){
				this.in_dateOfBirth.errorMsg = undefined;
			}
			
			this.$emit('input', this.in_dateOfBirth);
		},
		setInputFilter(textbox, inputFilter, maxLength) {
			["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
				textbox.addEventListener(event, function() {
				if (inputFilter(this.value)) {
					this.oldValue = this.value;
					this.oldSelectionStart = this.selectionStart;
					this.oldSelectionEnd = this.selectionEnd;
				} else if (this.hasOwnProperty("oldValue")) {
					this.value = this.oldValue;
					this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
				}
				});
			});
		}
		
		
	}
}
</script>